import { h } from 'preact';
export const Rss = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("path", { d: "M4 11a9 9 0 0 1 9 9" }),
        h("path", { d: "M4 4a16 16 0 0 1 16 16" }),
        h("circle", { cx: "5", cy: "19", r: "1" })));
};
//# sourceMappingURL=rss.js.map